import React from 'react'; // TODO: check

var ToastContext = /*#__PURE__*/React.createContext({
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onClose: function onClose() {}
});
export default ToastContext;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/esm/ToastContext.js
// module id = 661
// module chunks = 13